import { FunctionComponent } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { menu1, menu, skipedMenu } from '../Components/Sidnavbar/menuData';

interface PrivateRouteProps {
  element: React.ReactNode;
}
// Must be outside the component
const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  return { token, role };
};

const hasViewPermission = (locationName: string) => {
  const Menu = localStorage.getItem('role') == 'owner' ? menu1 : menu;
  console.log(Menu, localStorage.getItem('role'));
  // Check if the route has view permission
  const menuItem = Object.values(Menu)
    .flat()
    .flatMap((item) => {
      if (item.items) {
        return item.items.map((menu) => menu);
      }
      return item;
    })
    .find((item) => `/${item.to}` === locationName);

  return menuItem?.permissions?.view;
};

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ element }) => {
  const location = useLocation();
  const params = useParams();

  const locationName = Object.keys(params).length
    ? location.pathname.replace(/\/[^/]+$/, '')
    : location.pathname;

  const { token, role } = isAuthenticated();

  if (locationName === '/NotAuthorised') {
    return <>{element}</>;
  }

  if (token) {
    if (
      (hasViewPermission(locationName) || skipedMenu.includes(locationName)) &&
      ((role === "owner" &&
        (locationName.startsWith("/location") ||
          locationName.startsWith("/dashboard") ||
          locationName.startsWith("/Subscription") ||
          locationName.startsWith("/Sales"))) ||
        role !== "owner")
    ) {
      return <>{element}</>;
    } else {
      return (
        <Navigate
          to={"/login"}
          // to={'/NotAuthorised'}
          replace
        />
      );
    }
  } else {
    return (
      <Navigate
        to={'/login'}
        replace
      />
    );
  }
};

export default PrivateRoute;
